import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Col } from '../../utils/grid/Grid';
import Image from '../../utils/Image';
import Toggle from '../../utils/Toggle';
import ToggleSection from '../../utils/toggleSection/ToggleSection';
import HostTeaserBooking from '../hostTeaser/HostTeaserBooking';
import { getLimitationName, renderValue } from '../../helper/HostDetails';

import './booking-sidebar.css';

import axaLogo from './axa-logo.png';

const Limitations = (props) => (
  <ToggleSection className="sidebar-container-item" label={props.limitations_headline}>
    {props.limitations.map(({ label, value, limitation }, i) => (
      <div key={i} className="limitations-entry">
        <div className="limitations-label">{label}:</div>
        <div className={classNames('limitations-value', getLimitationName(value, limitation))}>
          {renderValue(value, limitation)}
        </div>
      </div>
    ))}
  </ToggleSection>
);

Limitations.propTypes = {
  limitations_headline: PropTypes.string,
  limitations: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      limitation: PropTypes.bool,
    }),
  ),
};

const BookingProcess = ({ headline, confirmation, paymentDetails }) => (
  <ToggleSection className="sidebar-container-item" label={headline}>
    <p>{confirmation}</p>
    <p>{paymentDetails}</p>
  </ToggleSection>
);

BookingProcess.propTypes = {
  headline: PropTypes.string.isRequired,
  confirmation: PropTypes.string.isRequired,
  paymentDetails: PropTypes.string.isRequired,
};

const BookingContact = ({ headline, content }) => (
  <ToggleSection className="sidebar-container-item" label={headline}>
    <p>{content}</p>
  </ToggleSection>
);

BookingContact.propTypes = {
  headline: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

const EuropeeneExplanation = ({ headline, content }) => (
  <ToggleSection className="sidebar-container-item" label={headline}>
    <p>{content}</p>
    <div className="sidebar-container-item-insurance-logo">
      <Image src={axaLogo} alt="Logo AXA" width="30" height="36" />
    </div>
  </ToggleSection>
);

EuropeeneExplanation.propTypes = {
  headline: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

const BookingSidebar = (props) => (
  <Toggle tagName={Col} show={props.show} xs={12} md={4}>
    <aside className="sidebar">
      <HostTeaserBooking {...props} />
      <div className="sidebar-container">
        {props.limitations ? <Limitations {...props} /> : null}
        <BookingProcess {...props.bookingProcess} />
        <BookingContact {...props.bookingContact} />
        <EuropeeneExplanation {...props.europeeneExplanation} />
      </div>
    </aside>
  </Toggle>
);

BookingSidebar.propTypes = {
  ...Limitations.propTypes,
  show: Toggle.propTypes.show,
  bookingProcess: PropTypes.shape(BookingProcess.propTypes),
  bookingContact: PropTypes.shape(BookingContact.propTypes),
};
export default BookingSidebar;
